angular
    .module("advanceSearchLOAra.components", [])
    .component("advanceSearchLoAra", {
        templateUrl: "ng/components/advanceSearchLOAra/advanceSearchLOAra.html",
        bindings: {
            startSearch: '&',
            showLoader: '<'
        },
        controllerAs: "advanceSearchLOAraCtrl",
        controller: advanceSearchLOAraController

    })

function advanceSearchLOAraController(
    $typeDomainService,
    $rootScope
) {

    var self = this;

    self.$onInit = function () {
        self.$rootScope = $rootScope;
        self.model = {
            ragSoc: '',
            statoAttivita: '',
            tipoAttivita: ''
        }
        self.dropdown = {
            type: [],
            stato: []
        }
        popolateDropdown();
    }

    var popolateDropdown = function () {
        $typeDomainService.getDomainSet('ACTIVITIES_OPS', 'TYPE')
            .then(function (response) {
                if (response) {
                    self.dropdown.type = response.domainList;
                }
            })


        $typeDomainService.getDomainSet('ACTIVITIES_OPS', 'STATUS')
            .then(function (response) {
                if (response) {
                    self.dropdown.stato = response.domainList;
                }
            })
    }
    self.search = function () {
        self.startSearch({
            filter: self.model
        })
    }


}